import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import './Chat.css';
import actions from './chat.actions';
import timeSince from '../timeSince';
import Icon from '../widgets/Icon';
import Spinner from '../widgets/Spinner';
import {Link} from 'react-router-dom';
import isiOSKeyboardOpen from '../isiOSKeyboardOpen';
import notificationActions from './notifications.actions.js';

const getPrettyDate = isoString =>
	isoString && timeSince(new Date(Date.parse(isoString)), undefined, false);

class Chat extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			newMessage: '',
			compensateForiOSKeyboard: false
		};

		this.updateNewMessage = e => {
			this.setState({
				newMessage: e.target.value
			});
		};

		this.submitMessage = () => {
			if (!this.state.newMessage || !this.props.chat) return; // Do nothing if blank
			this.props.submitMessage(
				this.props.chat.code,
				this.state.newMessage,
				this.props.chat.participants.map(part => part.user && part.user.uuid)
			);
			this.setState({
				newMessage: ''
			});
		};

		this.handleKeyPress = e => {
			if (e.key === 'Enter') {
				this.submitMessage();
				e.preventDefault();
			}
		};

		this.onInputFocus = () => {
			this.setState({
				compensateForiOSKeyboard: isiOSKeyboardOpen()
			});
		};

		this.onInputBlur = () => this.setState({compensateForiOSKeyboard: false});

		this.scrollMsgIntoView = () => {
			if (this.elMessages && this.elMessages.lastChild) {
				this.elMessages.lastChild.scrollIntoView();
			}
		};

		if (props.uuid) props.open();
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.uuid && nextProps.uuid) {
			nextProps.open();
		} else if (this.props.chat && this.props.chat.messages.length !== 0) {
			this.scrollMsgIntoView();
		}
	}

	componentDidUpdate() {
		this.scrollMsgIntoView();
	}

	componentDidMount() {
		this.scrollMsgIntoView();
	}

	render() {
		const {chat, sessionUser} = this.props;

		if (!sessionUser) return null;
		if (!chat) return <Spinner />;

		const {participants = [], messages = []} = chat;

		return (
			<section
				className={`Chat ${this.state.compensateForiOSKeyboard ? 'compensate-for-ios-kb' : ''}`}>
				<div className="Chat-header">
					<Link className="Chat-back" to="/chats">
						<Icon name="arrow_back" />
					</Link>
					<h2>
						{participants.map(part => (
							<Link
								to={`/@${part && part.profile && part.profile.uniqueName}`}
								key={part.user.uuid}>
								Go to {part && part.user && part.user.firstname ? part.user.firstname : 'New user'}
								's profile
							</Link>
						))}
					</h2>
				</div>
				<ol className="Chat-messages" ref={el => (this.elMessages = el)}>
					{messages &&
						messages.map((message, idx) => {
							const nextIsDifferentParticipant =
								!messages[idx + 1] || message.userUuid !== messages[idx + 1].userUuid;

							return (
								<li
									key={message.content + '_' + idx}
									className={`${message.userUuid ? 'Chat-received' : 'Chat-sent'} ${
										nextIsDifferentParticipant ? '' : 'grouped'
									}`}>
									<div className="Chat-content">{message.content}</div>

									{/* Only print sent date if consecutive sender is different */}
									{nextIsDifferentParticipant ? (
										<div className="Chat-details">
											{message.userUuid ? 'Received' : 'Sent'} {getPrettyDate(message.createdAt)}
										</div>
									) : null}
								</li>
							);
						})}
					{!messages || !messages.length ? (
						<div className="Chat-noMessages">
							Type below to send a message to{' '}
							{participants.map(part => part && part.user && part.user.firstname)}
						</div>
					) : null}
				</ol>

				<div className="Chat-input">
					<textarea
						onFocus={this.onInputFocus}
						onBlur={this.onInputBlur}
						spellCheck={true}
						maxLength={1024}
						className="Chat-entry"
						placeholder={'Type a message'}
						value={this.state.newMessage}
						onChange={this.updateNewMessage}
						onKeyPress={this.handleKeyPress}
					/>
					<button onClick={this.submitMessage}>
						<span className="icon-send" />
					</button>
				</div>
			</section>
		);
	}
}

export default connect(
	({session, chat}, {match}) => ({
		sessionUser: session && session.current && session.current.user.uuid,
		uuid: match && match.params && match.params.uuid,
		chat:
			chat &&
			chat.items &&
			chat.items.find(
				chat =>
					chat.code ===
						`${session && session.current && session.current.user.uuid}:${match &&
							match.params &&
							match.params.uuid}` ||
					chat.code ===
						`${match && match.params && match.params.uuid}:${session &&
							session.current &&
							session.current.user.uuid}`
			)
	}),
	(dispatch, {match}) => ({
		open: () => dispatch(actions.open(match && match.params && match.params.uuid)),
		submitMessage: (code, content, recipients) =>
			dispatch(actions.sendMessage(code, content, recipients))
	})
)(Chat);



// WEBPACK FOOTER //
// ./src/user/Chat.js